<script setup>
import DoughnutChart from './DoughnutChart.vue';
import ChartKey from './ChartKey.vue';

const props = defineProps({
    chartLabels: Array,
    dataValues: Array
  })
</script>

<template>
    <div class="row">
      <div class="col-sm-6">
        <DoughnutChart
          v-bind:chartLabels = "props.chartLabels"
          v-bind:dataValues = "props.dataValues">
        </DoughnutChart>
      </div>
      <div class="col-sm-6">
        <ChartKey
          v-bind:chartLabels = "props.chartLabels"
          v-bind:dataValues = "props.dataValues">
        </ChartKey>
      </div>
    </div>
</template>

